










import { Vue, Component } from 'vue-property-decorator';
import TipoMedida from '@/pantallas/TipoMedida/TipoMedida.vue';

@Component({
  components: { TipoMedida },
})
export default class TipoMedidaPantalla extends Vue {}
